module.exports = __webpack_public_path__ + "img/img5.dccb715d.jpg";